import type { Stats, Submission } from './api'
import type { SubmissionRow } from '../form-spam/form-spam-data'

const BOT_KEYS: Record<string, string> = {
	normal: 'clean',
	solved: 'passed',
	captcha_off: 'off',
	not_solved: 'failed',
	blocked: 'blockedHigh'
}
export const reportKey = (kind: 'email' | 'bot', key: string) =>
	kind === 'bot' ? BOT_KEYS[key] || key : key === 'spamTraps' ? 'spamTrap' : key
export function chartData(stats: Stats | null, kind: 'email' | 'bot') {
	const outcomes = stats?.[`${kind}_outcomes`] || []
	const totals: Record<string, number> = { total: 0 }
	const prev: Record<string, number> = { total: 0 }
	for (const outcome of outcomes) {
		const key = reportKey(kind, outcome.key)
		totals[key] = outcome.count
		totals.total += outcome.count
		prev[key] = outcome.previous_percentage
		if (outcome.previous_percentage > 0) prev.total = 100
	}
	const points = (stats?.[`${kind}_series`] || []).map((point) => ({
		day: new Date(`${point.day}T00:00:00Z`).toLocaleDateString('en-US', {
			month: 'short',
			day: 'numeric',
			timeZone: 'UTC'
		}),
		counts: Object.fromEntries(
			Object.entries(point.counts).map(([key, value]) => [
				reportKey(kind, key),
				value
			])
		)
	}))
	return { points, totals, prev }
}
export type ReportSubmissionRow = SubmissionRow & {
	formName: string
	formUrl: string
}
export function submissionRow(row: Submission): ReportSubmissionRow {
	const date = new Date(row.created_at)
	return {
		id: row.id,
		formId: row.form_id,
		formName: row.form_name || 'Unlinked form',
		formUrl: row.form_url,
		day: date.toLocaleDateString(undefined, {
			month: 'short',
			day: 'numeric',
			year: 'numeric'
		}),
		clock: date.toLocaleTimeString(undefined, {
			hour: '2-digit',
			minute: '2-digit'
		}),
		status: row.flagged ? 'flagged' : 'passed',
		outcome: reportKey('email', row.email_outcome) as SubmissionRow['outcome'],
		email: row.email || 'Email removed',
		ip: row.client_ip || '—',
		location:
			row.location || [row.city, row.country].filter(Boolean).join(', ') || '—',
		country: row.country || '',
		source: (row.source || 'Other') as SubmissionRow['source']
	}
}
